import React from "react";
//#region types
//#endregion
//#region
import { Checkbox, CheckboxProps } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const CheckBox: React.FC<CheckboxProps> = (props) => {
  return <Checkbox {...props} classes={{ root: cssExports.checkBox, checked: cssExports.checked }} />;
};

export default CheckBox;
